<template>
    <router-link :to="parseType(item.route)" :class="{ 'is-active': isActive }" @click="closeMenu">
        {{ item.text }}
    </router-link>
</template>

<script>
import has from 'lodash/has.js';

import ActiveStatusMixin from '@/mixins/ActiveStatus.mixin.js';

export default {
    name: 'NestedGeneric',

    mixins: [ActiveStatusMixin],

    props: {
        closeMenu: {
            type: Function,
            default: () => {},
        },

        item: {
            required: true,
            type: Object,
        },
    },

    methods: {
        parseType(route) {
            if (has(this.item, 'activity_type') && ['quiz'].some(check => check === this.item.activity_type)) return {};

            return route;
        },
    },
};
</script>
